import { render, staticRenderFns } from "./dash-hold-table.vue?vue&type=template&id=bc6e2626"
import script from "./dash-hold-table.vue?vue&type=script&lang=ts"
export * from "./dash-hold-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports